export default {
  refreshPromise: null,
  isRefreshing: false,
  isLogoutInProgress: false,
  isRateLimitActive: false
};
